import { X } from 'lucide-react'

interface VideoPreviewProps {
  src: string
  title: string
  subtitle?: string
  onRemove?: () => void
}

/**
 * Reusable video preview with autoplay loop, info bar, and optional remove button.
 * Used in Extend Video page and potentially other video selection flows.
 */
export function VideoPreview({ src, title, subtitle, onRemove }: VideoPreviewProps) {
  return (
    <div className="relative rounded-xl overflow-hidden border border-white/[0.08] bg-black">
      {/* Video Player */}
      <div className="aspect-video">
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-contain"
        />
      </div>
      
      {/* Video Info Bar */}
      <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/90 via-black/60 to-transparent">
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-white truncate">{title}</h3>
          {subtitle && (
            <p className="text-xs text-[#888] mt-0.5 truncate">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Remove Button */}
      {onRemove && (
        <button
          onClick={onRemove}
          className="absolute top-3 right-3 p-2 rounded-lg bg-black/60 text-white/80 hover:text-white hover:bg-black/80 transition-colors"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  )
}
